import WhitelabelConfig from '../features/edit-entity/components/whitelabelConfig';
import string from '../utils/string';

export const TiposCobranca = {
  MENSAL: 'MENSAL',
  FIDELIDADE: 'FIDELIDADE',
  ANUAL: 'ANUAL',
}
export const TiposCobrancaWhitelabel = {
  MENSAL: 'MENSAL',
  ANUAL: 'ANUAL',
}

export const getTiposCobrancaList = (isWhitelabel) => {
  const selectedTipo = Boolean(isWhitelabel)?TiposCobrancaWhitelabel:TiposCobranca
  return Object.keys(selectedTipo).map(value => ({
    value,
    name: string.capitalize(value)
  }));
}

